import { MessageFragment } from "src/state/gql/_types"
import { FormSchema } from "src/utils/forms"

export type SuperAdminThreadMessageCreateFragment = Pick<MessageFragment, 'body' | 'meta' >

export const SuperAdminThreadMessageCreateSchema: FormSchema<SuperAdminThreadMessageCreateFragment> = {
    id: "message",
    title: "Message",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        body: {
            group: 'default',
            label: "Message",
            type: "message-textarea",
            hideLabel: true,
            grid: 12,
            validation: {
                required: {
                    value: true,
                    message: '{field} is required'
                }
            }
        }
    }
}

export type SuperAdminThreadMessageUpdateFragment = Pick<MessageFragment, 'body' | 'meta' >

export const SuperAdminThreadMessageUpdateSchema: FormSchema<SuperAdminThreadMessageUpdateFragment> = {
    id: "message",
    title: "Message",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        body: {
            group: 'default',
            label: "Body",
            type: "message-textarea",
            grid: 12,
            validation: {
                required: {
                    value: false,
                    message: '{field} is required'
                }
            }
        }
    }
}